import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import idx from "idx";
import "./breadcumb.scss";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { useSelector } from "react-redux";

export default function Breadcumb(props) {
  const { children, projectId, serviceId } = props;
  const { projectDetail = {} } = useSelector(state => state)
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const serviceName = "";

  const projectList = () => {
    let projectType =
      searchParams.get("project-type")
      || idx(projectDetail, _ => _.project.projectDataType)
      || idx(projectDetail, _ => _.project.res.projectType)
      || 'MAJOR';
    navigate(`/projects?project-type=${projectType}`);
  };

  const viewProject = () => {
    navigate(`/projects/view/${projectId}`);
  };

  const serviceList = () => {
    navigate("/services");
  };

  const viewService = () => {
    navigate(`/services/view/${serviceId}`);
  };

  return (
    <>
      {projectId && (
        <>
          <ArrowCircleLeftOutlinedIcon
            className="arrow-circle-icon"
            onClick={() => navigate(-1)}
          />
          <span className="link" onClick={projectList}>
            Projects{" "}
          </span>
          <span className="arrow"> {"/"} </span>
          <span className={children ? "link" : ""} onClick={viewProject}>
            {idx(projectDetail, _ => _.project.projectName) || ''}
          </span>
          {children && <span className="arrow"> {"/"} </span>}
          {children}
        </>
      )}
      {serviceId && (
        <>
          <ArrowCircleLeftOutlinedIcon
            className="arrow-circle-icon"
            onClick={() => navigate(-1)}
          />
          <span className="link" onClick={serviceList}>
            Services
          </span>
          <span className="arrow"> {"/"} </span>
          <span className={children ? "link" : ""} onClick={viewService}>
            {serviceName}
          </span>
          {children && <span className="arrow"> {"/"} </span>}
          {children}
        </>
      )}
    </>
  );
};
